import { ECommerce } from "ui/forms/Onboarding";
import { Step, withStepData } from "ui/organizms/Onboarding/Applications/common";
import useMediaAndComplianceCheck from "./useMediaAndComplianceCheck";

const MediaAndComplianceCheck = () => {
    const mediaAndComplianceCheck = useMediaAndComplianceCheck();

    return (
        <Step
            title='Media & Compliance'
        >
            <ECommerce.MediaAndComplianceCheck.Form
                {...mediaAndComplianceCheck}
            />
        </Step>
    );
};

export default withStepData(MediaAndComplianceCheck);
